import React, { ReactNode } from 'react'
import { Box, Box as CustomerInfoBox, Box as CustomerWalletsBox } from '@node-space/ui-components'

export interface CustomerLayoutProps {
  CustomerWallets: ReactNode
  CustomerInfo: ReactNode
}

export const CustomerLayout = ({ CustomerWallets, CustomerInfo }: CustomerLayoutProps) => {
  return (
    <Box flexCol gap={16} width="full" justify="center" className="md:flex-row">
      <CustomerWalletsBox flexCol className="w-full break-words">
        {CustomerWallets}
      </CustomerWalletsBox>
      <CustomerInfoBox flexCol className="max-w-[320px] min-w-[260px] w-full">
        {CustomerInfo}
      </CustomerInfoBox>
    </Box>
  )
}
